/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useState, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Modal, Typography, Divider, Button, Row, Col, Spin, Space } from 'antd';
import { useToast } from '@chakra-ui/react';
import client from '../../../../api/api';

const { Text, Title, Paragraph } = Typography;

const media = {
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1366px)',
};

const Loading = styled.div`
  p.loading-list {
    font-size: 14px;
    color: #ffbb0f;
    margin-top: 45px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
`;

const Truckers = styled.div`
  .ad-trucker-assignment {
    position: absolute;
    left: 15px;
    width: 93%;
    background: #ffbb0f;
    padding: 20px;
    border-radius: 12px;
  }

  .ad-trucker-assignment h4 {
    color: #1c2023;
  }

  .ad-trucker-assignment p {
    color: gray;
    width: 100%;
  }
  .ad-trucker-assignment button {
    border-radius: 40px;
    background: #1c2023;
    color: #ffbb0f;
    margin-top: 10px;
    padding: 2px 30px;
    border: none;
  }

  .header {
    width: 100%;
    padding: 12px 20px 0;
    color: #ffbb0f;
    text-align: center;
  }

  ${media.desktop} {
    .ad-trucker-assignment {
      width: 300px;
      left: 20%;
    }

    .header {
      display: none;
    }
  }
`;

const TruckerListMobile = styled.ul`
  background: #1c2023;
  overflow-x: auto;
  list-style: none;
  white-space: nowrap;
  padding: 10px;

  h1 {
    color: #ffbb0f;
    margin-left: 12px;
  }

  ${media.desktop} {
    display: none;
  }
`;

const Headers = styled.div`
  display: none;
  ${media.desktop} {
    display: block;
    font-size: 12px;
    border-bottom: 1px solid #ffbb0f;
    margin-top: 30px;

    .humber-yellow {
      color: #ffbb0f;
    }

    p {
      display: inline-block;
      color: gray;
    }

    p.trucker-cuit {
      width: 88px;
      margin-left: 11px;
    }

    p.trucker-name {
      width: 200px;
      margin-left: 10px;
    }

    p.trucker-cel {
      width: 80px;
    }

    p.truck-license {
      width: 64px;
    }

    p.trailer-license {
      width: 66px;
    }

    p.truck-type {
      width: 100px;
    }

    p.status {
      width: 74px;
      text-align: center;
    }
  }
`;

const TruckerListDesktop = styled.ul`
  display: none;

  .humber-yellow {
    color: #ffbb0f;
  }

  ${media.desktop} {
    display: block;
    width: 95%;
    margin: 0 auto;

    li {
      padding: 5px 0;
      border-bottom: 1px solid gray;
    }

    li p {
      display: inline-block;
      font-size: 12px;
    }

    li p.trucker-premium {
      padding: 0 28px 0 15px;
    }

    li p.trucker-premium .premium {
      color: #ffbb0f;
    }

    li p.trucker-premium .no-premium {
      color: gray;
    }

    li p.trucker-name-value {
      width: 210px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      vertical-align: sub;
    }

    li p.trucker-cuit {
      width: 88px;
    }

    li p.trucker-cel-value {
      width: 80px;
    }

    li p.truck-patent,
    li p.trailer-patent {
      width: 68px;
    }

    li p.truck-body-type {
      width: 97px;
    }

    li p.trucker-status {
      text-align: center;
      width: 90px;
    }

    li .btn-add-disabled,
    li .btn-add {
      border: none;
      font-size: 12px;
      padding: 0 17px;
      background: #ffbb0f;
      outline: none;
    }

    li .btn-add-disabled {
      background: #30354e;
      color: gray;
    }

    li p .available {
      color: #19c482;
    }

    li p .on-the-road {
      color: #e25555;
    }
  }
`;

const Trucker = styled.li`
  display: inline-block;
  background: #333750;
  padding: 16px 26px 32px;
  margin: 30px 10px;
  border-radius: 22px;
  width: 240px;
  cursor: pointer;

  .humber-yellow {
    color: #ffbb0f;
  }

  .trucker-header h4,
  .premium-wrap {
    display: inline-block;
  }

  .premium-wrap {
    float: right;
  }

  .premium-wrap .premium {
    color: #ffbb0f;
    font-size: 20px;
  }

  .premium-wrap .no-premium {
    color: #1c2023;
    font-size: 20px;
  }

  h4.available {
    color: #19c482;
    font-weight: 300;
  }

  h4.not-available {
    color: red;
    font-weight: 300;
  }

  p {
    color: white;
  }

  p.trucker-name {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  label {
    color: gray;
    font-size: 12px;
    margin: 0%;
  }

  .available-wrap {
    width: 100%;
    text-align: right;
    padding-bottom: 10px;
  }

  .available-wrap .available {
    color: #ffbb0f;
    font-size: 20px;
  }
`;

const TruckerList = ({ load, assignedByUserId }) => {
  const {
    id: loadId,
    mandatoryBackgroundLocation,
    requestedVtv,
    relatedLoads,
    partialPayment,
  } = load;

  const toast = useToast();

  const [truckerList, setTruckerList] = useState(undefined);
  const [originalTrucker, setOriginalTrucker] = useState('');
  const [filterTrucker, setFilterTrucker] = useState('');
  const [truckerSelected, setTruckerSelected] = useState(undefined);
  const [errorMsg, setErrorMsg] = useState('');
  const [carrierEnabledToAssign, setCarrierEnabledToAssign] = useState(undefined);
  const [carrierEnabledToAssignLoaded, setCarrierEnabledToAssignLoaded] = useState(false);
  const [loadEnabledTruckers, setLoadEnabledTruckers] = useState(false);
  const [assingTruckerVisible, setAssingTruckerVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  // Helper para verificar pago parcial
  const hasPartialPayment = useCallback(() => {
    return partialPayment && Object.keys(partialPayment).length > 0;
  }, [partialPayment]);

  const fetchCarrierTruckers = useCallback(async () => {
    try {
      const { data } = await client.endpoints.carrier.getTruckers();
      setTruckerList(data.docs);
      setOriginalTrucker(data.docs);
    } catch (error) {
      console.error(error);
      setErrorMsg('No se pudieron obtener los camioneros de la flota');
    }
  }, []);

  const getCarrierEnabledForLoad = useCallback(async () => {
    try {
      const res = await client.endpoints.carrier.getCarrierEnabledForLoad(loadId);
      setCarrierEnabledToAssign(!!res.data);
    } catch (error) {
      if (error.response?.status === 404 && error.response.data === 'Carrier no habilitado') {
        console.warn(`El carrier no se encuentra habilitado para asignar esta carga(${loadId})`);
        setCarrierEnabledToAssign(false);
      } else {
        console.error(error);
        setErrorMsg('Hubo un error al buscar si el transportista está disponible o no');
      }
    } finally {
      setCarrierEnabledToAssignLoaded(true);
    }
  }, []);

  useEffect(() => {
    fetchCarrierTruckers();
    getCarrierEnabledForLoad();
  }, [fetchCarrierTruckers, getCarrierEnabledForLoad]);

  useEffect(() => {
    if (errorMsg) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [errorMsg]);

  useEffect(() => {
    if (originalTrucker) {
      setTruckerList(
        filterTrucker
          ? originalTrucker.filter(trucker => {
              return (
                trucker.name.toLowerCase().includes(filterTrucker.toLowerCase()) ||
                trucker.cuit.includes(filterTrucker)
              );
            })
          : originalTrucker
      );
    }
  }, [filterTrucker, originalTrucker]);

  const isTruckerEnabledForLoad = useCallback(async truckerId => {
    try {
      await client.endpoints.carrier.getTruckerEnabledForLoad(loadId, truckerId);

      return true;
    } catch (error) {
      if (error.response?.status === 404 && error.response.data === 'Trucker no habilitado') {
        return false;
      }

      console.error(error);
      setErrorMsg('Hubo un error al buscar si el camionero está disponible o no');
    }

    return true;
  }, []);

  const markEnabledTruckers = useCallback(async () => {
    const promises = truckerList.map(async trucker => {
      const { id, ...rest } = trucker;

      if (carrierEnabledToAssign) {
        return {
          id,
          enabledtoAssign: true,
          ...rest,
        };
      }

      const enabledtoAssign = await isTruckerEnabledForLoad(id);
      return {
        id,
        enabledtoAssign,
        ...rest,
      };
    });

    const newTruckerList = await Promise.all(promises);

    setLoadEnabledTruckers(true);
    setTruckerList(newTruckerList);
    setOriginalTrucker(newTruckerList);
  }, [truckerList, carrierEnabledToAssign, isTruckerEnabledForLoad]);

  useEffect(() => {
    if (!loadEnabledTruckers && carrierEnabledToAssignLoaded && truckerList) {
      markEnabledTruckers();
    }
  }, [loadEnabledTruckers, carrierEnabledToAssignLoaded, truckerList, markEnabledTruckers]);

  const reload = async () => {
    await fetchCarrierTruckers();
    await getCarrierEnabledForLoad();
    setLoadEnabledTruckers(false);
  };

  const renderStatus = useCallback(
    (trucker, isDesktop) => {
      const notAvailable = isDesktop ? 'on-the-road' : 'not-available';

      let className;
      let text;

      if (trucker.premium) {
        className = trucker.onTheRoad || !trucker.enabledtoAssign ? notAvailable : 'available';

        if (trucker.onTheRoad) {
          text = 'En viaje';
        } else {
          text = !trucker.enabledtoAssign ? 'No disponible' : 'Disponible';
        }
      } else {
        className = 'humber-yellow';
        text = 'No premium';
      }

      return isDesktop ? (
        <span className={className}>{text}</span>
      ) : (
        <h4 className={className}>{text}</h4>
      );
    },
    [truckerList]
  );

  const assignRelatedLoads = useCallback(
    async (truckerId, partialPaymentId) => {
      try {
        // Se asignan, de forma secuencial y en orden, las cargas enganchadas relacionadas.-
        for (let i = 0; i < relatedLoads.length; i += 1) {
          const relatedLoadId = relatedLoads[i];

          // Se descarta la actual (previamente asignada).-
          if (relatedLoadId !== loadId) {
            // eslint-disable-next-line no-await-in-loop
            await client.endpoints.carrier.createShipment(
              relatedLoadId,
              truckerId,
              partialPaymentId,
              assignedByUserId
            );
          }
        }
      } catch (error) {
        console.error(error);
        throw new Error(`Error al asignar alguna de las cargas enganchadas: ${relatedLoads}`);
      }
    },
    [loadId, relatedLoads, assignedByUserId]
  );

  const checkTruckerBackgroundLocation = async truckerUserId => {
    try {
      await client.endpoints.carrier.getBackgroundLocation(truckerUserId);

      return true;
    } catch (error) {
      if (error.response?.status === 400) {
        return false;
      }

      console.error(error);
      throw new Error('Error al obtener la ubicación en 2do plano del camionero');
    }
  };

  const checkVtv = async (truckId, plate) => {
    try {
      const {
        data: { isVtvOk },
      } = await client.endpoints.carrier.truckHasVtvUpToDate(truckId);

      return !!isVtvOk;
    } catch (error) {
      console.error(error);
      throw new Error(`Hubo un error al verificar la VTV con la patente del camión (${plate})`);
    }
  };

  const isValidTrucker = async truckerId => {
    const trucker = truckerList.find(tr => tr.truckerId === truckerId);

    const { id, cuit, name, legalName, isBlackList, premiumPhotos, truck, billingData } = trucker;

    const titleError = `No se pudo agregar a ${name || legalName} (${cuit})`;
    const errorDetails = [];

    if (isBlackList) {
      errorDetails.push('Se encuentra en la lista negra de Humber.');
    }

    const isPremiumPhotosOK = !!premiumPhotos?.licenseFrontPhoto && !!premiumPhotos?.licenseFrontPhotoConfirmed;

    if (!isPremiumPhotosOK) {
      errorDetails.push('No tiene la foto de licencia del chofer subida o no está aprobada.');
    }

    if (!billingData) {
      errorDetails.push('No tiene datos de facturación registrados en Humber.');
    }

    let isBackgroundLocationOk;
    if (mandatoryBackgroundLocation) {
      isBackgroundLocationOk = await checkTruckerBackgroundLocation(id);

      if (!isBackgroundLocationOk) {
        errorDetails.push('No posee la ubicación en 2do plano activada y la carga lo requiere.');
      }
    }

    if (!truck || !truck.trailer) {
      errorDetails.push('No tiene camión (tractor o remolque) registrados en Humber.');
    }

    let isVtvOk;
    if (requestedVtv && truck) {
      isVtvOk = await checkVtv(truck.id, truck.plate);

      if (!isVtvOk) {
        errorDetails.push('La VTV no se encuentra al día y la carga lo requiere.');
      }
    }

    const isValid =
      !isBlackList &&
      isPremiumPhotosOK &&
      (!mandatoryBackgroundLocation || (mandatoryBackgroundLocation && isBackgroundLocationOk)) &&
      !!truck &&
      !!truck?.trailer &&
      (!requestedVtv || (requestedVtv && isVtvOk)) &&
      !!billingData;

    if (!isValid) {
      Modal.error({
        width: 600,
        title: titleError,
        content: (
          <Space direction="vertical">
            <Text>Motivos:</Text>
            {errorDetails.map(err => (
              <Space key={err} align="start">
                <Text strong>-</Text>
                <Text>{err}</Text>
              </Space>
            ))}
          </Space>
        ),
      });
    }

    return isValid;
  };

  const assignTruckerToLoad = async (truckerId, acceptPromotion) => {
    try {
      const partialPaymentId = acceptPromotion ? partialPayment.id : null;

      await client.endpoints.carrier.createShipment(
        loadId,
        truckerId,
        partialPaymentId,
        assignedByUserId
      );

      // Se asignan también las cargas enganchadas, si las tuviera.-
      if (relatedLoads) {
        await assignRelatedLoads(truckerId, partialPaymentId);
      }

      toast({
        title: 'Viaje creado exitosamente!',
        status: 'success',
        isClosable: true,
      });
    } catch (error) {
      console.error(error);
      throw new Error('Error al crear viaje/s para el camionero');
    }
  };

  const handleOnOk = useCallback(
    async (truckerId, acceptPromotion) => {
      try {
        setLoading(true);

        // Validaciones necesarias.-
        if (await isValidTrucker(truckerId)) {
          await assignTruckerToLoad(truckerId, acceptPromotion);

          reload();
        }
      } catch (error) {
        console.error(error);
        setErrorMsg('Ocurrió un error al asignar el camionero a la carga');
      } finally {
        setLoading(false);
        setAssingTruckerVisible(false);
      }
    },
    [assingTruckerVisible, isValidTrucker, assignTruckerToLoad]
  );

  const handleClose = () => {
    setAssingTruckerVisible(false);
  };

  const renderAssignButton = useCallback(
    trucker => {
      if (!trucker.premium) {
        return '';
      }
      const disabled = trucker.onTheRoad || !trucker.enabledtoAssign;
      return (
        <Button
          className={disabled ? 'btn-add-disabled' : 'btn-add'}
          disabled={disabled}
          onClick={async () => {
            setAssingTruckerVisible(true);
            setTruckerSelected(trucker);
            setErrorMsg('');
          }}
        >
          Asignar
        </Button>
      );
    },
    [truckerList]
  );

  const handleSubmit = acceptPromotion => {
    // Si no hay promoción y acceptPromotion es false, es "Cancelar" (solo cerrar modal)
    if (!hasPartialPayment() && acceptPromotion === false) {
      handleClose();
      return;
    }

    // En todos los demás casos, proceder con la asignación
    handleOnOk(truckerSelected.truckerId, acceptPromotion);
  };

  return (
    <>
      <Truckers>
        <div className="humber-input filter-wrapper">
          <label htmlFor="search">
            Buscar
            <input
              id="search"
              type="text"
              className="form-control"
              value={filterTrucker}
              onChange={event => setFilterTrucker(event.target.value)}
            />
          </label>
        </div>
        {truckerList ? (
          <>
            {errorMsg !== '' ? <p className="error-msg">{errorMsg}</p> : ''}
            <TruckerListMobile>
              <h1>Mi flota</h1>
              {truckerList.map(trucker => (
                <Trucker
                  key={trucker.id}
                  onClick={async () => {
                    if (!trucker.premium) {
                      return;
                    }
                    setAssingTruckerVisible(true);
                    setTruckerSelected(trucker);
                    setErrorMsg('');
                  }}
                >
                  <div className="trucker-header">
                    {renderStatus(trucker, false)}
                    <div className="premium-wrap">
                      <p>
                        <FontAwesomeIcon
                          className={trucker.premium ? 'premium humber-yellow' : 'no-premium'}
                          icon={faCrown}
                        />
                      </p>
                    </div>
                  </div>
                  <label>Chofer</label>
                  <p className="trucker-name">{trucker.name}</p>
                  <label>CUIT Chofer</label>
                  <p>{trucker.cuit}</p>
                  <label>Cel</label>
                  <p>{trucker.phoneNumber}</p>
                  <label>Tractor</label>
                  <p>{trucker.truck ? trucker.truck.plate : 'Sin camión'}</p>
                  <label>Remolque</label>
                  <p>{trucker.truck?.trailer ? trucker.truck.trailer.plate : 'Sin trailer'}</p>
                  <label>Carrocería</label>
                  <p>
                    {trucker.truck?.trailer?.trailerType
                      ? trucker.truck.trailer.trailerType.name
                      : 'Sin tipo de carrocería'}
                  </p>
                </Trucker>
              ))}
            </TruckerListMobile>
            <TruckerListDesktop>
              <Headers>
                <p className="trucker-premium">Premium</p>
                <p className="trucker-name">Chofer</p>
                <p className="trucker-cuit">CUIT Chofer</p>
                <p className="trucker-cel">Cel</p>
                <p className="truck-license">Tractor</p>
                <p className="trailer-license">Remolque</p>
                <p className="truck-type">Carrocería</p>
                <p className="status">Status</p>
              </Headers>
              {truckerList.map(trucker => (
                <li key={trucker.id}>
                  <p className="trucker-premium">
                    <FontAwesomeIcon
                      className={trucker.premium ? 'premium humber-yellow' : 'no-premium'}
                      icon={faCrown}
                    />
                  </p>
                  <p className="trucker-name-value">{trucker.name}</p>
                  <p className="trucker-cuit">{trucker.cuit}</p>
                  <p className="trucker-cel-value">{trucker.phoneNumber}</p>
                  <p className="truck-patent">
                    {trucker.truck ? trucker.truck.plate : 'Sin camión'}
                  </p>
                  <p className="trailer-patent">
                    {trucker.truck?.trailer ? trucker.truck.trailer.plate : 'Sin trailer'}
                  </p>
                  <p className="truck-body-type">
                    {trucker.truck?.trailer?.trailerType
                      ? trucker.truck.trailer.trailerType.name
                      : '...'}
                  </p>
                  <p className="trucker-status">{renderStatus(trucker, true)}</p>
                  {renderAssignButton(trucker)}
                </li>
              ))}
            </TruckerListDesktop>
          </>
        ) : (
          <Loading>
            <p className="loading-list">Cargando listado de camioneros...</p>
          </Loading>
        )}
      </Truckers>

      <Modal
        destroyOnClose
        title={`Asignar a ${truckerSelected?.name} ${
          hasPartialPayment() ? ' - Viaje con pago contado' : ''
        }`}
        visible={assingTruckerVisible}
        onCancel={handleClose}
        footer={[
          <Button
            key="notAccepted"
            type="default"
            onClick={() => handleSubmit(false)}
            loading={loading}
          >
            {hasPartialPayment() ? 'Agregar y NO aceptar' : 'Cancelar'}
          </Button>,
          <Button
            key="accepted"
            type="primary"
            onClick={() => handleSubmit(true)}
            loading={loading}
          >
            {hasPartialPayment() ? 'Agregar y aceptar' : 'Agregar'}
          </Button>,
        ]}
      >
        <Spin spinning={loading} tip="Asignando camionero..." size="large">
          {hasPartialPayment() && (
            <>
              <Title level={2} style={{ color: '#c760fb', textAlign: 'center' }}>
                {`${partialPayment.firstPaymentPercentage}/${100 -
                  partialPayment.firstPaymentPercentage}`}
              </Title>
              <Title level={5} style={{ color: '#c760fb', textAlign: 'center' }}>
                Si acepto la promoción, ¿cómo recibe el pago el camionero/transportista?
              </Title>
              <Divider />
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Title level={4}>{`${partialPayment.gasoilOrderPercentage}%`}</Title>
                </Col>
              </Row>
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Paragraph>
                    En una orden de carga de gasoil en <strong>Shell Flota</strong> al subir la foto
                    de inicio del viaje.
                  </Paragraph>
                </Col>
              </Row>
              <Divider />
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Title level={4}>{`${partialPayment.firstPaymentPercentage -
                    partialPayment.gasoilOrderPercentage}%`}</Title>
                </Col>
              </Row>
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Paragraph>
                    A los <strong>{partialPayment.daysToFirstPayment}</strong> días hábiles luego de
                    luego de liquidado el viaje.
                  </Paragraph>
                </Col>
              </Row>
              <Divider />
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Title level={4}>{`${100 - partialPayment.firstPaymentPercentage}%`}</Title>
                </Col>
              </Row>
              <Row justify="center">
                <Col span={24} style={{ textAlign: 'center' }}>
                  <Paragraph>En la fecha de pago según la carga publicada..</Paragraph>
                </Col>
              </Row>
              <Divider />
            </>
          )}
          <Paragraph>
            Al seleccionar un camionero, te comprometes a realizar el viaje. Se cobrará un recargo
            por asignar un chofer y no realizar el viaje. Si tienes dudas, contáctanos
          </Paragraph>
          <Paragraph>
            Al aceptar, se enviará un mensaje de <Text strong>WhatsApp</Text> al camionero para que
            confirme si los datos de facturación y la patente son correctos.
          </Paragraph>
        </Spin>
      </Modal>
    </>
  );
};

TruckerList.propTypes = {
  load: PropTypes.shape({
    id: PropTypes.string.isRequired,
    mandatoryBackgroundLocation: PropTypes.bool.isRequired,
    requestedVtv: PropTypes.bool.isRequired,
    relatedLoads: PropTypes.arrayOf(PropTypes.string),
    partialPayment: PropTypes.object,
  }).isRequired,
  assignedByUserId: PropTypes.string,
};

export default TruckerList;
